<template>
  <div>
    <div class="bg-white relative shadow-md rounded border border-gray-400">
      <div class="flex flex-col lg:flex-row rounded overflow-hidden">
        <div class="w-full lg:w-64 bg-gray-200 py-2">
          <nav class="nav">
            <div
              class="nav__item cursor-default capitalize"
              :class="{ active: currentTab === 'TAB_GENERAL' }"
              @click="currentTab = 'TAB_GENERAL'"
            >
              general
            </div>
            <div
              class="nav__item cursor-default capitalize"
              :class="{ active: currentTab === 'TAB_ROLES' }"
              @click="currentTab = 'TAB_ROLES'"
            >
              roles
            </div>
            <div
              class="nav__item cursor-default capitalize"
              :class="{ active: currentTab === 'TAB_SECURITY' }"
              @click="currentTab = 'TAB_SECURITY'"
            >
              security
            </div>
            <div
              class="nav__item cursor-default capitalize"
              :class="{ active: currentTab === 'TAB_NOTIFICATION_SETTINGS' }"
              @click="currentTab = 'TAB_NOTIFICATION_SETTINGS'"
            >
              notification settings
            </div>
          </nav>
        </div>
        <div class="w-full lg:flex-1 p-16">
          <Transition name="fade" mode="out-in" :duration="150">
            <!--
              General Tab
            -->
            <GeneralForm
              v-if="currentTab === 'TAB_GENERAL'"
              key="general"
              :submitting="loading"
              :first-name="user.firstName"
              :last-name="user.lastName"
              :username="user.name"
              class="space-y-16 mx-auto w-full lg:w-3/5 xl:w-2/5"
              @submit="onSubmit"
            />

            <!--
              Roles Tab
            -->
            <RolesForm
              v-else-if="currentTab === 'TAB_ROLES'"
              key="roles"
              :submitting="loading"
              :user-role-ids="user.roles"
              :roles="included.roles"
              class="space-y-16 mx-auto w-full lg:w-3/5 xl:w-2/5"
              @submit="onSubmit"
            />

            <!--
              Security Tab
            -->
            <SecurityForm
              v-else-if="currentTab === 'TAB_SECURITY'"
              key="security"
              :submitting="loading"
              class="space-y-16 mx-auto w-full lg:w-3/5 xl:w-2/5"
              @submit="onSubmit"
            />

            <!--
              Notification Settings Tab
            -->
            <NotificationSettings
              v-else-if="currentTab === 'TAB_NOTIFICATION_SETTINGS'"
              :user-id="user.id"
              key="notification_settings"
              class="mx-auto w-full"
            />
          </Transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralForm from './GeneralForm.vue';
import RolesForm from './RolesForm.vue';
import SecurityForm from './SecurityForm.vue';
import NotificationSettings from './NotificationSettings.vue';

const TAB_GENERAL = 'TAB_GENERAL';
const TAB_ROLES = 'TAB_ROLES';
const TAB_SECURITY = 'TAB_SECURITY';
const TAB_NOTIFICATION_SETTINGS = 'TAB_NOTIFICATION_SETTINGS';

export default {
  name: 'UserInfo',
  components: {
    GeneralForm,
    RolesForm,
    SecurityForm,
    NotificationSettings,
  },
  props: {
    loading: Boolean,
    user: {
      type: Object,
      required: true,
    },
    included: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    currentTab: TAB_GENERAL,
  }),
  computed: {
    tab() {
      const tabs = {
        TAB_GENERAL,
        TAB_ROLES,
        TAB_SECURITY,
        TAB_NOTIFICATION_SETTINGS,
      };

      return tabs[this.currentTab] || tabs[TAB_GENERAL];
    },
  },
  methods: {
    onSubmit(value) {
      this.$emit('submit', value);
    },
  },
};
</script>
